import React from "react";
import { Header } from "../../../components/Header";
import "./style.css";

const Reading = () => {
  return (
    <div className="reading">
      <div className="main-content">
      <div className="reading-option">
        <div className="overlap">
          <div className="gradient">
            <div className="overlap-group">
              <img className="ellipse" alt="Ellipse" src="https://c.animaapp.com/tgSF4QvL/img/ellipse-10.svg" />
              <img className="img" alt="Vector" src="https://c.animaapp.com/tgSF4QvL/img/vector-6.svg" />
              <div className="div" />
              <div className="ellipse-2" />
            </div>
          </div>
          <div className="text-backgorund" />
          <div className="option-background" />
          <div className="option-background-2" />
          <p className="site-text">
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et
            dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet
            clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet,
            consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat,
            sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no
            sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing
            elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At
            vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est
            Lorem ipsum dolor sit amet.
          </p>
          <p className="option-text">
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et
            dolore magna aliquyam erat, sed diam voluptua. At
          </p>
          <p className="p">
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et
            dolore magna aliquyam erat, sed diam voluptua. At
          </p>
        </div>
        <Header
          className="header-instance"
          menuIconDefaultImgClassName="header-4"
          menuIconDefaultImgClassNameOverride="header-5"
          menuIconDefaultVectorClassName="header-2"
          menuIconDefaultVectorClassNameOverride="header-3"
        />
      </div>
    </div>
    <div className="mobile-warning">
      Diese Website ist noch nicht für kleinere Displays optimiert. Bitte wechseln sie zu einem 16:9 Display.
    </div>
    </div>
  );
};

export default Reading;